import React, { useState, useEffect, useRef } from "react";
import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const slides = [{
  id: 1,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/hero_wellness_limestone.png",
  title: "Holistic Wellness Redefined",
  subtitle: "Experience a refined approach to healthcare that balances clinical excellence with a compassionate touch in the heart of Cyprus."
}, {
  id: 2,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/hero_medical_care.png",
  title: "Advanced Medical Expertise",
  subtitle: "Specialized treatments and personalized health insights delivered by leading medical experts in Limassol and Nicosia."
}, {
  id: 3,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/hero_sanctuary_healing.png",
  title: "A Sanctuary for Healing",
  subtitle: "Discover a tranquil environment dedicated to your recovery and long-term physical well-being with our integrated care pathways."
}];
export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        setScrollY(window.scrollY);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  };
  return <section data-section-id="40747" id="hero" ref={sectionRef} className="relative h-screen min-h-[600px] w-full overflow-hidden bg-[#F8F8F6] text-[#1A1A2E]">
      {}
      {slides.map((slide, index) => <div key={slide.id} data-index={index} className={`absolute inset-0 h-full w-full transition-opacity duration-1000 ease-in-out ${index === currentSlide ? "opacity-100 z-10" : "opacity-0 z-0"}`}>
          <div className="absolute inset-0 h-[120%] w-full bg-cover bg-center transition-transform duration-75 ease-out opacity-40" style={{
        backgroundImage: `url(${slide.image})`,
        transform: `translateY(${scrollY * 0.5}px)`
      }} />
          {}
          <div className="absolute inset-0 bg-[#F8F8F6]/30 mix-blend-overlay" />
          {}
          <div className="absolute inset-0 bg-[#F8F8F6]/40" />
          {}
          <div className="absolute inset-0 bg-gradient-to-t from-[#F8F8F6]/80 via-transparent to-[#F8F8F6]/20" />
        </div>)}

      {}
      <div className="relative z-20 flex h-full w-full items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl text-center">
          <div className="space-y-6">
            {}
            <h1 className="font-sans text-xs font-semibold uppercase tracking-widest text-[#3B8FD4]">
              Condition & Treatment
            </h1>

            {}
            <h2 className="font-serif text-4xl font-medium tracking-tighter text-[#1A1A2E] sm:text-5xl md:text-6xl lg:text-[4.5rem] leading-[1.1] drop-shadow-sm">
              {slides[currentSlide].title}
            </h2>

            {}
            <p className="mx-auto max-w-[60ch] font-sans text-lg leading-[1.6] text-[#4A5568] sm:text-xl">
              {slides[currentSlide].subtitle}
            </p>

            {}
            <div className="flex justify-center pt-4">
              <Button asChild className="h-auto rounded-lg bg-[#3B8FD4] px-10 py-4 text-base font-semibold text-white shadow-md transition-all hover:bg-[#3B8FD4]/90 hover:scale-105 active:scale-95">
                <Link to="/TreatmentsPage" className="flex items-center gap-2">
                  Explore Treatments
                  <ArrowRight className="h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-0 right-0 z-30 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-7xl items-center justify-between">
          {}
          <div className="font-sans text-sm font-medium tracking-widest text-[#1A1A2E]/60">
            {String(currentSlide + 1).padStart(2, "0")} /{" "}
            {String(slides.length).padStart(2, "0")}
          </div>

          {}
          <div className="flex gap-2">
            <Button onClick={prevSlide} variant="ghost" size="icon" className="group h-10 w-10 rounded-lg border border-[#1A1A2E]/10 bg-white/50 text-[#1A1A2E] backdrop-blur-sm transition-colors hover:bg-[#1A1A2E] hover:text-white" aria-label="Previous slide">
              <ChevronLeft className="h-5 w-5" />
            </Button>
            <Button onClick={nextSlide} variant="ghost" size="icon" className="group h-10 w-10 rounded-lg border border-[#1A1A2E]/10 bg-white/50 text-[#1A1A2E] backdrop-blur-sm transition-colors hover:bg-[#1A1A2E] hover:text-white" aria-label="Next slide">
              <ChevronRight className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-1/2 z-20 hidden -translate-x-1/2 pb-8 md:block">
        <div className="flex flex-col items-center gap-2 opacity-40">
          <span className="text-[10px] uppercase tracking-widest text-[#1A1A2E]">
            Scroll
          </span>
          <div className="h-12 w-[1px] bg-gradient-to-b from-[#1A1A2E] to-transparent" />
        </div>
      </div>
    </section>;
}